import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-cream flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white rounded-3xl border border-line p-8 shadow-sm">
        <div className="flex items-center gap-2 mb-8">
          <span className="w-9 h-9 rounded-full bg-sage text-cream flex items-center justify-center"><Leaf className="w-4 h-4" /></span>
          <span className="font-serif text-xl font-semibold">VITA Admin</span>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <Input type="email" required placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          <Input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-sage py-3 text-sm font-semibold text-cream hover:bg-ink transition-colors disabled:opacity-60">
            {loading ? "…" : "Log in"}
          </button>
        </form>
      </div>
    </main>
  );
}
